<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <vue-html2pdf
                    :show-layout="false"
                    :float-layout="true"
                    :enable-download="false"
                    :preview-modal="true"
                    :paginate-elements-by-height="1400"
                    :filename="data.customer+' '+data.bulanNama+'-'+data.tahun"
                    :pdf-quality="2"
                    :manual-pagination="false"
                    pdf-format="a4"
                    pdf-orientation="landscape"
                    pdf-content-width="1120px"
                    :html-to-pdf-options="data.htmlToPdfOptions"
                    ref="html2Pdf" style="width:100%">
                    <section slot="pdf-content" style="width:100%">
                        <div ref="print" class="card" style="width:100%">
                            <div class="card-body" style="width:100%;padding:20px;background-color:white;">
                                <div class="header"
                                style="display:flex;">
                                    <div class="header-left" style="flex:2">
                                        <div class="logo-box">
                                            <img style="height:100px;" :src="data.urlaset+''+data.ptlogoUploaded" alt="">
                                        </div>
                                        <div class="info-box" style="display:flex;">
                                            <div class="dari-box" style="flex:1">
                                                <span style="padding-left:10px;display:block;background-color:orange;color:white;font-weight:bold">Customer</span>
                                                <div class="dari-inner" style="padding-left:10px">
                                                    <span style="display:block;font-weight:bold">{{data.customer}}</span>
                                                    <span>{{data.alamat}}</span>
                                                </div>
                                            </div>
                                            <div class="dari-box" style="flex:1">
                                                <span style="padding-left:10px;display:block;background-color:orange;color:white;font-weight:bold">Dari</span>
                                                <div class="dari-inner" style="padding-left:10px">
                                                    <span style="display:block;font-weight:bold">{{data.ptnama}}</span>
                                                    <span>{{data.ptalamat}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="header-right" style="flex:1;margin-left:20px;">
                                        <h3 style="text-align:center;border-bottom:1px solid #333">Invoice</h3>
                                        <span style="display:block;font-weight:bold">Bulan : {{data.bulanNama}} {{data.tahun}}</span>
                                        <span style="display:block;font-weight:bold">Jatuh Tempo : {{data.tgl_tagihan}} {{data.bulanNama}} {{data.tahun}}</span>
                                        <span style="display:block;font-weight:bold">No. Invoice : #INV-{{data.invoice}}</span>
                                    </div>
                                </div>
                                <div class="content">
                                    <table class="table">
                                        <thead style="background-color:orange">
                                            <th>Description</th>
                                            <th>Qty</th>
                                            <th>Price</th>
                                            <th>Discount</th>
                                            <th>Total</th>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Dedicated Access {{data.product}} mpbs</td>
                                                <td>1</td>
                                                <td>{{data.harga}}</td>
                                                <td>{{data.diskon}}</td>
                                                <td>{{data.total}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{data.bulanNama}} {{data.tahun}}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>Total</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>{{data.total}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="footerbox" style="display:flex">
                                    <div class="footer-box" style="flex:1;">
                                        <div class="dari-inner" style="padding-left:10px">
                                            <span style="display:block;">Note : </span>
                                            <span style="display:block;">Transfer Via</span>
                                            <span style="display:block;">{{data.ptan}}</span>
                                            <span>{{data.ptbank}} : {{data.ptrek}}</span>
                                        </div>
                                    </div>
                                    <div class="footer-box" style="flex:1;"></div>
                                    <div class="footer-box" style="flex:1;">
                                        <div class="dari-inner" style="padding-left:10px;text-align:center;">
                                            <span style="display:block;">Hormat Kami</span>
                                            <img style="height:100px;" :src="data.urlaset+''+data.ptttdUploaded" alt="">
                                            <span style="display:block;">Finance</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </vue-html2pdf>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="card">
                        <div class="p-2">
                            <span class="d-block text-center text-warning">Belum Bayar</span>
                            <h3 class="m-0 text-center" v-if="data.belumTotal != '0'">{{myGlobal.ribu(data.belumTotal)}}</h3>
                            <div class="m-0 text-center" v-else>
                                <span>&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</span>
                                <i class="material-icons ml-2 text-info pointer" style="font-size: 14pt;" @click="theGet.jumlah('belum')">remove_red_eye</i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card">
                        <div class="p-2">
                            <span class="d-block text-center text-success">Lunas</span>
                            <h3 class="m-0 text-center" v-if="data.lunasTotal != '0'">{{myGlobal.ribu(data.lunasTotal)}}</h3>
                            <div class="m-0 text-center" v-else>
                                <span>&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</span>
                                <i class="material-icons ml-2 text-info pointer" style="font-size: 14pt;" @click="theGet.jumlah('lunas')">remove_red_eye</i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card">
                        <div class="p-2">
                            <span class="d-block text-center text-info">Total Bandwith (mb)</span>
                            <h3 class="m-0 text-center">{{data.allBandwith}}</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <router-link :to="{ name: 'tambah-mitra'}"  class="btn btn-primary" v-if="myGlobal.RootOnly()">Tambah Mitra</router-link>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                    <div class="card-header card-header-info">
                        <div class="row">
                        <div class="col-md-6">
                            <h4 class="card-title ">Mitra</h4>
                            <p class="card-category">Berikut daftar Mitra anda</p>
                        </div>
                        <div class="col-md-6" v-show="false">
                            <h2 class="card-title text-right">{{data.filtered}}</h2>
                        </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                        <table class="table">
                            <thead class=" text-info">
                            <th width="40px">No.</th>
                            <th>Nama</th>
                            <th>Alamat</th>
                            <th>Area</th>
                            <th>Tgl Tagihan</th>
                            <th>Bandwith (mb)</th>
                            <th>Harga</th>
                            <th>Diskon</th>
                            <th>Total</th>
                            <th>
                                Ket
                                </br>
                                <small class="text-muted">({{data.bulanNama}} {{data.tahun}})</small>
                            </th>
                            <th>Aksi</th>
                            </thead>
                            <tbody>
                                <tr v-for="(u, index) in theGet.data.List">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ u.data.nama }}  </br> {{ u.data.wa }} </br> 
                                        <strong v-if="u.data.status == 'need_acc'" class="mt-2 text-info d-inline-block">Butuh Acc</strong>
                                        <strong v-else-if="u.data.status == 'reject'" class="mt-2 text-danger d-inline-block">Menolak Koneksi</strong>
                                    </td>
                                    <td>{{ u.data.alamat }}</td>
                                    <td>{{ u.data.area }}</td>
                                    <td>{{ u.data.tgl_tagihan }}</td>
                                    <td>
                                        <span class="text-info" v-if="u.data.bw != null">{{ u.data.bw }}</span>
                                        <span class="text-info" v-else>{{ u.data.up }}</span>
                                    </td>
                                    <td>{{ ribu(u.data.harga) }}</td>
                                    <td>{{ ribu(u.data.diskon) }}</td>
                                    <td>{{ ribu(parseInt(u.data.harga) - parseInt(u.data.diskon)) }}</td>
                                    <td>
                                        <span class="text-success" v-if="u.lunas">Lunas</span>
                                        <span class="text-danger" v-else>
                                            Belum Lunas
                                            <small v-if="u.sudah_bayar != null" class="text-info"><br>Sudah Bayar : {{ ribu(u.sudah_bayar) }}</small>
                                            <small v-if="u.sisa_bayar != null" class="text-warning"><br>Sisa Bayar : {{ ribu(u.sisa_bayar) }}</small>
                                        </span>
                                    </td>
                                    <td>
                                        <button class="btn btn-sm btn-success d-inline-flex align-items-center" title="Bayar" v-if="!u.lunas" @click="data.bayar = true, data.bayarData = u.data, data.sisa_bayar = u.sisa_bayar"><span class="material-icons">payments</span>&nbsp;Bayar</button>
                                        <router-link :to="{ name: 'detail-mitra', params: { data: u.data  }}" class="btn btn-sm btn-info"><span class="material-icons">remove_red_eye</span></router-link>
                                        <button v-if="myGlobal.RootOnly()" class="btn btn-sm btn-warning  d-inline-flex align-items-center" 
                                        @click="
                                            data.up = true, 
                                            data.mid = u.data.mid, 
                                            data.bid = u.data.bid,
                                            data.nama = u.data.nama,
                                            data.bwnow = u.data.bw,
                                            data.bwnowup = u.data.up
                                        "
                                        ><span class="material-icons">edit</span> Upgrade</button>
                                        <router-link v-if="myGlobal.RootOnly()" :to="{ name: 'tambah-mitra', params: { data: u.data  }}" class="btn btn-sm btn-info  d-inline-flex align-items-center"><span class="material-icons">edit</span> Edit</router-link>
                                        <button v-show="false" class="btn btn-sm btn-danger"><span class="material-icons">delete_outline</span></button>
                                        <button class="btn btn-sm btn-secondary" title="Download Invoice"  @click="theGet.pdf(u.data)"><span class="material-icons">print</span></button>
                                        <button v-if="myGlobal.RootOnly()" class="btn btn-sm btn-danger" title="Download Invoice"  @click="data.modalHapus = true;data.namaHapus = u.data.nama;data.midHapus = u.data.mid"><span class="material-icons">delete_outline</span></button>
                                    </td>
                                </tr>
                                <tr v-if="theGet.data.List == null">
                                    <td></td>
                                    <td>Tidak ada Data </td>
                                </tr>
                                <tr>
                                    <td colspan="10"><button class="btn btn-info" @click="theGet.loadmore()">Load More</button></td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
                </div>
                
            </div>

            <!-- MODAL -->
            <div class="modal" tabindex="-1" role="dialog" v-show="data.up">
                <div class="overlay"></div>
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Upgrade Bandwith</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.up = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Nama</label>
                                        <span class="form-control">{{data.nama}}</span>
                                    </div>
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Bandwith Sekarang (mbps)</label>
                                        <span class="form-control" v-if="data.bwnow != null">{{data.bwnow}}</span>
                                        <span class="form-control" v-else>{{data.bwnowup}}</span>
                                    </div>
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Up ke (mis: 1000, tanpa comma)</label>
                                        <input type="number" class="form-control" placeholder="Up..." v-model="data.bwup">  
                                    </div>
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Harga (mis: 1000000, tanpa comma)</label>
                                        <input type="number" class="form-control" placeholder="Harga..." v-model="data.harga">  
                                        <small class="text-muted" v-show="data.harga != ''">{{myGlobal.ribu(data.harga)}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="data.up = false">Batal</button>
                            <button type="button" class="btn btn-success" @click="data.up = false,theGet.submit()">Simpan</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MODAL -->
            <div class="modal" tabindex="-1" role="dialog" v-show="data.bayar">
                <div class="overlay"></div>
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Bayar Tagihan</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.bayar = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Nama</label>
                                        <span class="form-control">{{data.bayarData.nama}} - {{data.bayarData.wa}}</span>
                                    </div>
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Alamat</label>
                                        <span class="form-control">{{data.bayarData.alamat}}</span>
                                    </div>
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Bandwith</label>
                                        <span class="form-control" v-if="data.bayarData.bw != null">{{data.bayarData.bw}}</span>
                                        <span class="form-control" v-else>{{data.bayarData.up}}</span>
                                    </div>
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Harga</label>
                                        <span class="form-control">{{myGlobal.ribu(data.bayarData.harga)}}</span>
                                    </div>
                                    <div class="form-group">
                                        <label class="bmd-label-floating text-success">Diskon</label>
                                        <span class="form-control">{{myGlobal.ribu(data.bayarData.diskon)}}</span>
                                    </div>
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Total</label>
                                        <span class="form-control">{{myGlobal.ribu( parseInt(data.bayarData.harga) - parseInt(data.bayarData.diskon) )}}</span>
                                    </div>
                                    <div class="form-group" v-if="data.sisa_bayar > 0">
                                        <label class="bmd-label-floating text-warning">Sisa Bayar</label>
                                        <span class="form-control text-warning">{{myGlobal.ribu( data.sisa_bayar )}}</span>
                                    </div>
                                    <div class="form-group">
                                        <label class="bmd-label-floating text-success">Bayar (Kosongkan jika bayar lunas) <span class="text-danger" v-if="data.sisa_bayar > 0"><br>Hanya bayar sisa Bayar</span></label>
                                        <input type="number" class="form-control" placeholder="Bayar..." v-model="data.bayarJumlah" style="width: 300px">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="data.bayar = false">Batal</button>
                            <button type="button" class="btn btn-success" @click="data.bayar = false,theGet.bayar()">Simpan</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MODAL -->
            <div class="modal" tabindex="-1" role="dialog" v-show="data.modalHapus">
                <div class="overlay"></div>
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Hapus Mitra</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalHapus = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Hapus Mitra "{{data.namaHapus}}"?</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-success" @click="data.modalHapus = false">Batal</button>
                            <button type="button" class="btn btn-secondary" @click="data.modalHapus = false,theGet.hapus()">Hapus</button>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import { urlAssets } from '@/var/var.js'
import VueHtml2pdf from 'vue-html2pdf'

Vue.use(moment)

export default {
    name: 'Beranda',
    components: { 
        VueHtml2pdf

    }, 
    setup() {
        const data = reactive({
            dis: '',
            up: false,
            mid: '',
            bid: '',
            nama: '',
            bwnow: '',
            bwnowup: '',
            bwup: '',
            harga: '',
            
            diskon: '',
            total: '', // untuk print
            invoice: '',

            allTotal: 0,
            allBandwith: 0,
            belumTotal: 0,
            lunasTotal: 0,

            bayar: false,
            bayarData: '',
            sisa_bayar: 0,

            bayarJumlah: null,

            urlaset: '',
            bulanNama: '', bulan: '',tahun: '', customer: '', alamat: '', tgl_tagihan: '', invoice: '', product: '',
            ptemail: '', ptnama: '', ptalamat: '', ptrek: '', ptan: '',  ptlogoUploaded: '',  ptttdUploaded: '', ptbank: '',


            htmlToPdfOptions: {
                margin: 0,
 
                filename: `Invoice.pdf`,
            
                image: {
                    type: 'jpeg', 
                    quality: 0.98
                },
            
                enableLinks: false,
            
                html2canvas: {
                    scale: 1,
                    letterRendering: true,
                    useCORS: true
                },
            
                jsPDF: {
                    unit: 'in',
                    format: 'a4',
                    orientation: 'landscape'
                }
            },

            modalHapus: false,
            namaHapus: '',
            midHapus: '',

            page: 0,
            pageStat: 0

        })

        const theGet = {
            data: reactive({
                List: [],
            }),
            pdf(u) {
                data.customer = u.nama;
                data.alamat = u.alamat;
                data.tgl_tagihan = u.tgl_tagihan;
                if (u.bw != null) {
                    data.product = u.bw;
                } else {
                    data.product = u.up;
                }
                
                var datac = u;
                let bwLast;
                if (datac.bwnow != null) {
                    bwLast = datac.bw;
                } else {
                    bwLast = datac.up;
                }
                
                data.harga = myGlobal.ribu(datac.harga);    
                data.diskon = myGlobal.ribu(datac.diskon);    
                data.total = myGlobal.ribu(parseInt(datac.harga) - parseInt(datac.diskon));    

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    mid: datac.mid,
                    harga: datac.harga,
                    diskon: datac.diskon,
                    bw: bwLast,
                    bulan: data.bulan,
                    tahun: data.tahun
                }
				
                var apiUrl = inter.MitraBlankBayar();
				
				myGlobal.call(datax,apiUrl).then(x => {
                    data.invoice = x.data.invoice;
                    data.dis.$refs.html2Pdf.generatePdf()
				})      
            },
            pt() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken')
                }
                
                var apiUrl = inter.getPerusahaan();
                myGlobal.call(datax,apiUrl).then(x => {

                    //console.log(JSON.stringify(x));
                    
                    if (x.status == true) {
                        //data.datae = x.data;

                        var d = x.data.pt;
 
                        data.ptemail = x.data.email;
                        data.ptnama = d.nama;
                        data.ptalamat = d.alamat;
                        data.ptrek = d.rek;
                        data.ptan = d.an;
                        data.ptbank = d.bank;
                        data.ptlogoUploaded = "perusahaan_logo/"+d.logo;
                        data.ptttdUploaded = "perusahaan_ttd/"+d.ttd;
            
                    } else {

                        //this.form.alert = x.pesan;

                    }
                    
                })
            },
            datae() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    bulan: data.bulan,
                    tahun: data.tahun,
                    page: data.page
                };

                data.lunasTotal = 0;
                    
                var apiUrl = inter.MitraList();
                myGlobal.call(datax,apiUrl).then(x => {

                    //console.log(JSON.stringify(x));
                    
                    if (x.status == true) {
                        if(data.page == 0) {
                            this.data.List = x.data;
                        } else {

                            let data = x.data;

                            let i;
                            for (i = 0; i < data.length; i++) {
                                var item1 = data[i];

                                this.data.List.push(item1);
                            }
                        }
                        
                        /*
                        for (let i = 0; i < datax.length; i++) {
                            if (datax[i].lunas) {
                                    data.lunasTotal = parseInt(data.lunasTotal) + (parseInt(datax[i].data.harga) - parseInt(datax[i].data.diskon));
                            } else {
                                if(datax[i].sisa_bayar != null) {
                                    data.belumTotal = parseInt(data.belumTotal) + (parseInt(datax[i].sisa_bayar));
                                } else {
                                    data.belumTotal = parseInt(data.belumTotal) + (parseInt(datax[i].data.harga) - parseInt(datax[i].data.diskon));
                                }
                                
                                if(datax[i].sudah_bayar != null) {
                                    data.lunasTotal = parseInt(data.lunasTotal) + (parseInt(datax[i].sudah_bayar));
                                }

                                data.allTotal = parseInt(data.allTotal) + (parseInt(datax[i].data.harga) - parseInt(datax[i].data.diskon));
                            }
                        }
                        */

                        // total bandwith
                        data.allBandwith = 0;
                        var datax = this.data.List;
                        for (let i = 0; i < datax.length; i++) {
                            if (datax[i].data.bw == null) {
                                data.allBandwith = parseInt(data.allBandwith) + parseInt(datax[i].data.up);
                            } else {
                                data.allBandwith = parseInt(data.allBandwith) + parseInt(datax[i].data.bw);
                            }
                        }


                    } else {
                        //alert(x.pesan);
                        data.pageStat = 999;
                    }
                })
            },
            loadmore() {
                if(data.pageStat == 999) {
                    alert("Tidak ada data lagi");
                    return false;
                }

                data.page = data.page + 1;

                
                console.log("loadmore "+data.page);

                theGet.datae();

            },
            jumlah(status) {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    bulan: data.bulan,
                    tahun: data.tahun,
                    status: status
                };

                // data.lunasTotal = 0;
                    
                var apiUrl = inter.MitraJumlah();
                myGlobal.call(datax,apiUrl).then(x => {

                    console.log(JSON.stringify(x));
                    
                    if (x.status == true) {   
                        let d = x.data; 
                        
                        if(status == 'belum') {
                            data.belumTotal = d.harga;
                        } else if(status == 'lunas') {
                            data.lunasTotal = d.harga;
                        }


                    } else {
                        //alert(x.pesan);
                        
                    }
                })
            },
            bayar() {
                var datac = data.bayarData;
                let bwLast;
                if (datac.bwnow != null) {
                    bwLast = datac.bw;
                } else {
                    bwLast = datac.up;
                }

                if(parseInt(data.bayarJumlah) > parseInt(datac.harga)) {
                    alert("Bayar tidak boleh lebih dari harga "+datac.harga+ " bayarnya " + data.bayarJumlah);
                    return false;
                }

                if(parseInt(data.sisa_bayar) > 0) {
                    if(parseInt(data.bayarJumlah) > parseInt(data.sisa_bayar)) {
                        alert("Bayar tidak boleh lebih dari Sisa Bayar");
                        return false;
                    }
                }
                
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    mid: datac.mid,
                    harga: datac.harga,
                    diskon: datac.diskon,
                    bw: bwLast,
                    bulan: data.bulan,
                    tahun: data.tahun,
                    bayar: data.bayarJumlah
                }
                

                console.log(JSON.stringify(data.bayarJumlah));
				
                var apiUrl = inter.MitraBayar();
				
				myGlobal.call(datax,apiUrl).then(x => {
					if (x.status) {
                        theGet.datae();
					} else {

					}
				})

            },
			submit() {

                var datac = data;

                if (datac.bwup == "") {
                    //data.alert = true;
                    //data.alertText = "Nama tidak boleh kosong";
                    return false;
                }

                if (datac.harga == "") {
                    //data.alert = true;
                    //data.alertText = "Nama tidak boleh kosong";
                    return false;
                }

                //data.alert = false;
                
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    mid: datac.mid,
                    bwup: datac.bwup,
                    harga: datac.harga
                }
				
                var apiUrl = inter.MitraUp();
				
				myGlobal.call(datax,apiUrl).then(x => {
					if (x.status) {
                        theGet.datae();
					} else {

					}
				})
			},
            hapus() {
                
                var datac = data;
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    mid: datac.midHapus,
                }
				
                var apiUrl = inter.MitraHapus();
				
				myGlobal.call(datax,apiUrl).then(x => {
                    console.log(JSON.stringify(x))
					if (x.status) {
                        theGet.datae();
					} else {

					}
				})
            }
        }

        return {
            data, 
            theGet,
            myGlobal
        }

    },
    mounted () {
        document.title = "Mitra";
        this.data.bulan =  myGlobal.getBulan();
        this.data.bulanNama = sessionStorage.getItem('bulanNamaBase');
        this.data.tahun = sessionStorage.getItem('tahunBase');

        this.theGet.datae();
        this.theGet.pt();

        this.data.urlaset = urlAssets;



        this.data.dis = this;
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/mitra/main.vue